// lbl.login.

export const login = {
    welcome_burgerking: "ยินดีต้อนรับสู่  เบอร์เกอร์คิง",
    phoneNo: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'เบอร์โทรศัพท์',
        required: '',
        too_short: '',
        invalid: '',
    },
    sign_in: 'ลงชื่อเข้าใช้',
    or: 'หรือ',
    don_t_have_an_account: 'ไม่มีบัญชีผู้ใช้',
    create_account: 'สมัครบัญชีผู้ใช้',
    continue_as: 'เริ่มใช้งานแบบ',
    guest: 'ผู้ใช้ชั่วคราว',
    phoneNoRequire: {
        name: 'เบอร์โทรศัพท์ (เบอร์มือถือไทยเท่านั้น)',
        placeholder: 'เบอร์โทรศัพท์ (เบอร์มือถือไทยเท่านั้น)',
        required: 'กรุณาระบุหมายเลขโทรศัพท์มือถือ 10 หลัก',
        too_short: 'กรุณาระบุหมายเลขโทรศัพท์มือถือ 10 หลัก',
        invalid: '',
    },
    name: {
        name: 'ชื่อ',
        placeholder: 'ชื่อ',
        required: 'กรุณาระบุชื่อ',
        too_short: '',
        invalid: '',
    },
    read_accept: 'คุณได้ยืนยันว่าได้อ่านและยอมรับ',
    term: 'ข้อกำหนดการใช้งาน',
    and: 'และ',
    privacy: 'คำชี้แจงว่าด้วยความเป็นส่วนตัว',
    of_burgerking: 'ของ บริษัท เบอร์เกอร์ (ประเทศไทย) จำกัด แล้ว',

    i_agree: 'I agree to receive the information including other marketing activities from Burger King and',
    affiliated_companies: 'บริษัทในเครือและแบรนด์ที่เกี่ยวข้อง',
    learn_more: 'Learn more about',
    privacy_policy: 'privacy policy',
    form_company: "from company's website.",

    i_interest: 'ฉันสนใจและต้องการรับข้อมูลข่าวสารเกี่ยวกับสินค้า บริการ ของแถม ส่วนลด โปรโมชั่น และกิจกรรมต่างๆ ที่เกี่ยวข้องจาก เบอร์เกอร์คิง และ',

    submit: 'ถัดไป',

    confirm_guest: {
        look_like: 'Looks like you are an exiting customer',
        with: 'with this mobile number',
        what: "คุณต้องการจะ",
        login: 'เข้าสู่ระบบ',
        continue_as_guest: 'ดำเนินการต่อโดยไม่สมัครสมาชิก'
    },

    please_setup_pin: 'ตั้งค่า PIN',
    enter_your_pin: 'กรอก PIN',
};
